import type { Module } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";

export interface ListViewState {
  page: number;
  perPage: number;
  orderBy: { field: string; direction: string };
  filterString: string;
  filters: Record<string, unknown>;
}

export interface SavedListState {
  filters?: Record<string, unknown>;
  search?: ListViewState;
}

interface ListState {
  lists: Record<string, SavedListState>;
}

const listStateModule: Module<ListState, unknown> = {
  state: () => ({ lists: {} }),
  getters: {
    savedListState:
      (state) =>
      (key: string): SavedListState | undefined =>
        state.lists[key],
  },
  mutations: {
    saveListState(state, payload: { key: string; value: SavedListState }) {
      state.lists[payload.key] = {
        ...state.lists[payload.key],
        ...JSON.parse(JSON.stringify(payload.value)),
      };
    },
    clearListSearch(state, key: string) {
      if (state.lists[key]) delete state.lists[key].search;
    },
    [Mutations.PURGE_AUTH](state) {
      state.lists = {};
    },
  },
};

export default listStateModule;
